import { Alert, Button, Divider, Input, Typography, message } from "antd";
import React, { useState } from "react";
import { apiCall } from "../../utils/Api";

export default function GoogleFontFetch(props) {

    const { close = () => { }, save = () => { } } = props;
    const [valid, setValid] = useState("");
    const [data, setData] = useState({
        name: "",
        path: "",
        error: "",
    })

    // Upload the file
    const uploadFont = (_file) => {
        let ext = _file.name.split(".").pop();
        apiCall("files/uploadfont", { file: _file, file_name: data.name + "." + ext }, (_status, _result) => {
            if (_status) {
                message.success("Font uploaded");
                save({
                    synthetic: false,
                    name: data.name + "." + ext,
                    path: "/bm_site_content_fonts/" + data.name + "." + ext,
                    is_import: false,
                }, true)
                close();
            } else {
                setData({ ...data, "error": "Error uploading font." })
            }
        })
    }

    // Download the file
    const downloadFont = (_path) => {
        fetch(_path)
            .then(response => {
                if (response.status === 200) {
                    return response.blob();
                } else {
                    console.log(response)
                }
            })
            .then(data => {
                const file = new File([data], "temp.woff2", {
                    type: "font/woff2",
                });
                uploadFont(file)
            })
            .catch(error => {
                setData({ ...data, "error": "Error downloading Google font." })
            });
    }

    const getLatinFont = (_str) => {
        const regex = /\/\*\s*latin\s*\*\/[\s\S]*?src:\s*url\((.*?)\)/;
        const match = regex.exec(_str);
        const font = match ? match[1] : null;
        if (font) {
            downloadFont(font);
        } else {
            setData({ ...data, "error": "Error fetching latin font version." })
        }
    }

    const stripTag = (_str) => {
        return _str.replace(/<style>|<\/style>|\s*(@import[^;]*;)\s*|\n|\r/g, '$1');
    }

    const validateGoogleFont = (_val) => {
        _val = stripTag(_val);
        let urlRegex = /@import\s+url\(['"]([^'"]+)['"]\);?/;
        let match = _val.match(urlRegex);
        // Check if there is a match and retrieve the URL
        if (match && match[1]) {
            _val = match[1];
            setValid("");
            setData({ ...data, path: _val })
        } else {
            setValid("Incorrect format.")
        }
    }


    const fetchFont = async () => {
        try {
            const response = await fetch(data.path);
            const result = await response.text();
            getLatinFont(result);
        } catch (error) {
            setData({ ...data, "error": "Error fetching Google font." })
        }
    };

    return (
        <>
            <div style={{ "padding": "20px" }}>
                <Typography.Title level={5}>Upload Google Font</Typography.Title>
                <Divider style={{ "margin": "15px 0px" }} dashed />
                <Alert style={{ "lineHeight": "10px", "marginBottom": "15px" }} description={<div style={{ "lineHeight": "14px" }}><small>The Google Font file will be uploaded to your Content → Site Uploads menu on Biz.</small></div>} />
                <label>Font Name:</label>
                <Input disabled={data.error} onChange={(e) => setData({ ...data, "name": e.target.value })} placeholder="Name..." />
                <div className="shim" />
                <label>Google Font Import:</label>
                <Input.TextArea disabled={data.error} onChange={(e) => validateGoogleFont(e.target.value)} placeholder="@import...." rows={4} />
                {(valid && <div style={{ "color": "#f00" }}><div className="shim" /><div className="shim" />{valid}</div>)}
                {(data.error && <div style={{ "color": "#f00" }}><div className="shim" /><div className="shim" />{data.error}</div>)}
               <div className="shim" /><div className="shim" />
                <div className="float-flex">
                    <div>&nbsp;</div>
                    {(data.error &&
                        <Button onClick={() => close()}><small>Close</small></Button>
                    )}
                    {(!data.error &&
                        <Button type="primary" onClick={() => fetchFont()} disabled={!data.name || data.error}><small>Upload font</small></Button>
                    )}
                </div>
            </div>
        </>
    );
}